import api from '@/lib/api'

export default {
  async getPricingParamsDB ({ commit, state, dispatch }) {
    try {
      let payload = await api.getPricingParamsDBAPI()
      return payload
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },
  async updatePricingParamsDB ({ dispatch }, params) {
    try {
      const resp = await api.updatePricingParamsDBAPI(params)
      dispatch('addTemporalNotification', { type: 'success', message: resp.message })
      return true
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },
  async getMarketPricesDB ({ commit, state, dispatch }) {
    try {
      let payload = await api.getMarketPricesDBAPI()
      return payload
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },
  async csvDownloadMarketPricesDB ({ dispatch }) {
    try {
      let { payload } = await api.csvDownloadMarketPricesDBAPI()
      return payload
    } catch (error) {
      return false
    }
  },
  async csvEditTemplateMarketPricesDB ({ dispatch }) {
    try {
      let { payload } = await api.csvEditTemplateMarketPricesDBAPI()
      return payload
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },
  async bulkUpdateMarketPricesDB ({ dispatch }, updates) {
    try {
      const resp = await api.bulkUpdateMarketPricesDBAPI(updates)
      dispatch('addTemporalNotification', { type: 'success', message: resp.message })
      return resp
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },
  async updateMarketPriceDB ({ dispatch }, { id, median }) {
    try {
      const resp = await api.updateMarketPriceDBAPI(id, median)
      dispatch('addTemporalNotification', { type: 'success', message: resp.message })
      return true
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  }
}
